import React, { useEffect, useState } from "react";
import {
  isAvatarUrlLoadFailed,
  markAvatarUrlFailed,
} from "../../utils/avatarLoadGuard.js";

function __asStr(v) {
  return String(v ?? "").trim();
}

/** Avatar / Initialen / Platzhalter — gleiche Zielgröße wie .app-topbar__avatar. */
export function AuthAvatarFace({ avatarUrl, initials }) {
  const url = __asStr(avatarUrl);
  const ini = __asStr(initials);
  const [imgFailed, setImgFailed] = useState(() => isAvatarUrlLoadFailed(url));

  useEffect(() => {
    setImgFailed(isAvatarUrlLoadFailed(url));
  }, [url]);

  const showImg = Boolean(url) && !imgFailed;

  if (showImg) {
    return (
      <img
        src={url}
        alt=""
        className="app-topbar__avatar"
        decoding="async"
        referrerPolicy="no-referrer"
        onError={() => {
          markAvatarUrlFailed(url);
          setImgFailed(true);
        }}
      />
    );
  }
  if (ini) {
    return (
      <span
        className="app-topbar__avatar app-topbar__avatarInitials"
        aria-hidden="true"
      >
        {ini}
      </span>
    );
  }
  return <span className="hub-header__user-icon" aria-hidden="true" />;
}
